import {TOGGLE_WEBSITE_SIDEBAR, ToggleWebsiteSidebar} from "../actions/website-sidebar.action";

export interface IWebsiteSidebar {
  toggled: boolean;
}

export const initialState: IWebsiteSidebar = {
  toggled: false
};

export function reducer(state: IWebsiteSidebar = initialState, action: ToggleWebsiteSidebar): any {

  switch (action.type) {

    case TOGGLE_WEBSITE_SIDEBAR:
      return {
        ...state,
        toggled: !state.toggled,
      };
  }

  return state;
}
